<template>
    <div class="mb-1">
        <label
            class="form-label"
            :class="{ 'form-label--disabled': disabled }"
            :for="name"
        >
            {{ label }}
        </label>

        <textarea
            :id="name"
            class="form-input"
            :class="{
                'form-input--error': error,
                'form-input--disabled': disabled
            }"
            :disabled="disabled"
            :name="name"
            :placeholder="placeholder"
            :rows="rows"
            :value="value"
            @input="onInput"
        />

        <div class="form-error" :class="{ 'form-error--visible': error }">
            {{ error }}
        </div>
    </div>
</template>

<script>
import FormComponentMixin from '@/js/mixins/form-component-mixin';

export default {
    mixins: [FormComponentMixin],

    props: {
        placeholder: {
            type: String,
            default: ''
        },
        rows: {
            type: Number,
            default: 10
        },
        value: {
            type: String,
            default: ''
        }
    },

    computed: {
        showErrorElement() {
            const field = this.$parent.$validator.fields.find({
                name: this.name
            });
            return field !== undefined;
        }
    },

    methods: {
        onInput(e) {
            this.$emit('input', e.target.value);
        }
    }
};
</script>

<style lang="scss" scoped>
.form-input {
    padding: 10px 20px;
    resize: none;
}
</style>
